import React from "react";
import { cn } from "../utils/style";

function TextInput({
  label,
  id,
  name,
  type,
  required,
  get,
  set,
  readOnly,
  disabled,
  format,
  className,
  placeholder,
}) {
  return (
    <div className={cn("space-y-2", className)}>
      <label
        htmlFor={id}
        className="block text-[11px] font-black uppercase tracking-wider text-slate-500 px-1 ms-1"
      >
        {label}{" "}
        {required && (
          <span className="text-red-500" aria-label="Required">
            *
          </span>
        )}
      </label>
      <div className="relative group">
        <input
          id={id}
          name={name}
          type={type || "text"}
          value={get || ""}
          disabled={disabled}
          format={format || null}
          onChange={(e) => set(e.target.value)}
          required={required || false}
          readOnly={readOnly || false}
          placeholder={placeholder}
          min={0}
          className={cn(
            "block w-full rounded-xl border-slate-200 bg-slate-50/50 py-3 px-4 text-sm font-bold text-slate-900 transition-all duration-300 shadow-sm",
            "placeholder:text-slate-400 placeholder:font-medium",
            "focus:border-primary-500 focus:bg-white focus:ring-4 focus:ring-primary-500/10 focus:shadow-md outline-none",
            "disabled:opacity-50 disabled:bg-slate-100 disabled:cursor-not-allowed",
            readOnly && "bg-slate-50 border-slate-100 cursor-default",
          )}
        />
      </div>
    </div>
  );
}

export default TextInput;
